<template>
  <news-list :noticeClass="noticeClass" />
</template>
<script>
import NewsList from "./news-list";
export default {
  name: "news-policy",
  components: {
    NewsList,
  },
  data() {
    return {
      noticeClass: 2,
    };
  }
};
</script>

<style lang="scss" scoped>
</style>